/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Contract_Reference_HintInputs */

const en_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown in your billing settings or contract email.`)
};

const de_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den Abrechnungseinstellungen oder der Vertrags-E-Mail angegeben.`)
};

const fr_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indiquée dans les paramètres de facturation ou l’e-mail du contrat.`)
};

const es_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparece en los ajustes de facturación o en el correo del contrato.`)
};

const it_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicato nelle impostazioni di fatturazione o nell’e-mail del contratto.`)
};

const nl_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermeld in factuurinstellingen of contractmail.`)
};

const pl_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widoczny w ustawieniach rozliczeń lub wiadomości o umowie.`)
};

const fi_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näkyy laskutusasetuksissa tai sopimusviestissä.`)
};

const da_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vises i faktureringsindstillingerne eller kontraktmailen.`)
};

const sv_consumer_declaration_contract_reference_hint = /** @type {(inputs: Consumer_Declaration_Contract_Reference_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visas i faktureringsinställningarna eller avtalsmeddelandet.`)
};

/**
* | output |
* | --- |
* | "Shown in your billing settings or contract email." |
*
* @param {Consumer_Declaration_Contract_Reference_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_contract_reference_hint = /** @type {((inputs?: Consumer_Declaration_Contract_Reference_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Contract_Reference_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "fr") return fr_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "es") return es_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "it") return it_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "nl") return nl_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "pl") return pl_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "fi") return fi_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "da") return da_consumer_declaration_contract_reference_hint(inputs)
	if (locale === "sv") return sv_consumer_declaration_contract_reference_hint(inputs)
	return en_consumer_declaration_contract_reference_hint(inputs)
});